/*
 * module.js - The description of the module.
 */

Fundu.Components.Finance = (function($) {

    // State
    ///////////////////////////
    var _isInitialized = false;

    // Properties
    ///////////////////////////
    var _transactionMenuElement = false;

    var _transfereInElement = false;
    var _transfereInProfileElement = false;
    var _transfereInAmountElement = false;
    var _transfereButton = false;

    var _transfereOutElement = false;
    var _transfereOutProfileElement = false;
    var _transfereOutAmountElement = false;
    var _withdrawButton = false;

    var _investInLoanElement = false;
    var _investProfileLoanElement = false;
    var _investProfileShareElement = false;
    var _investLoanAmountElement = false;
    var _investButton = false;
    var _investInLoanButton = false;

    var _investInShareElement = false;
    var _investInShareButton = false;
    var _transferAndInvestInShareButton = false;
    var _investShareAmountElement = false;

    var _sharePriceTotal = false;
    var _sharePrice = 0;
    var _minimumShares = false;
    var _maximumShares = false;
    var _availableShares = false;

    var _confirmView = false;
    var _confirmAmount = false;
    var _confirmPriceTotal = false;
    var _amountToTransfer = false;
    var _amountToTransferSpan = false;
    var _confirmCheckbox = false;
    var _showConfirmShareInvestment = false;
    var _hideConfirmShareInvestment =  false;

    var _showConfirmLoanInvestment = false;
    var _hideConfirmLoanInvestment = false;
    var _confirmLoanView = false;
    var _confirmLoanCheckbox = false;
    var _confirmLoanAmount = false;

    var _guaranteeButton = false;
    var _guaranteeAmount = false;
    var _guaranteeLoanId = false;

    var _loanId = false;
    var _shareId = false;
    var _csrfToken = false;

    var _balances = {};
    var _pbwHash = false;

    var _fundedAmount = false;

    // Private Methods
    ///////////////////////////

    // Select elements from HTML
    var selectElements = function() {
        _transactionMenuElement = $("#transaction-menu");

        _transfereInElement = $("#transfereIn");
        _transfereInProfileElement = $("#select-profile-in");
        _transfereInAmountElement = $("#amont-in");
        _transfereButton = $('.transfere.btn');

        _transfereOutElement = $("#transfereOut");
        _transfereOutProfileElement = $("#select-profile-out");
        _transfereOutAmountElement = $("#amont-out");
        _withdrawButton = $('.withdraw.btn');

        _investInLoanElement = $("#investInLoan");

        _investProfileLoanElement = $('#select-profile-invest-loan');
        _investLoanAmountElement = $('#investInLoan input#amount-invest');

        _confirmView = $('#panel-invest div.confirm');
        _confirmAmount = $('#panel-invest .confirm .amount');
        _confirmPriceTotal = $('#panel-invest .confirm .price');

        _investInLoanButton = $('#colInvest .invest.btn');
        _guaranteeButton = $('#guarantee .guarantee.btn');
        _guaranteeAmount = $('#amount-guarantee');

        _showConfirmLoanInvestment = $('#investInLoan .confirm.btn');
        _hideConfirmLoanInvestment = $('#colInvest .cancel.clickable');
        _confirmLoanView = $('#colInvest div.confirm');
        _confirmLoanCheckbox = $('#colInvest #acceptTerms');
        _confirmLoanAmount = $('#colInvest .confirm .amount');

        selectShareElements();
    }

    var selectShareElements = function() {
        _investInShareElement = $("#investInShare");
        _investProfileShareElement = $('#select-profile-invest-share');
        _investShareAmountElement = $('#investInShare input#amount-invest');

        _sharePriceTotal = $('#investInShare span.price');
        _amountToTransfer = $('#panel-invest .confirm .amountToTransfer');
        _amountToTransferSpan = $('#panel-invest .confirm .amountToTransferSpan');

        _confirmCheckbox = $('#panel-invest #acceptTerms');
        _showConfirmShareInvestment = $('#investInShare .confirm.btn');
        _hideConfirmShareInvestment = $('#panel-invest .cancel.btn');

        _investInShareButton = $('#panel-invest .confirm .invest.btn');
        _transferAndInvestInShareButton = $('#panel-invest .confirm .transferAndInvest.btn');
    };

    // Check that the elements exist and unbind them
    var checkElements = function() {
        var groups = $("#select-profile-in option");
        groups.each(
                function(index){
                    var groupID = $(this).val();
                    var amount = $(this).data('balance');

                    // Check that balance is set
                    if(!amount) return;

                    amount = String(amount).replace(/\s/g, '');
                    var groupBalance = parseFloat(amount);

                    _balances[groupID] = groupBalance;
                }
        );

        var loanIdInput =  $("#investInLoan input[name=loanId]");
        var shareIdInput =  $("#investInShare input[name=shareId]");
        var sharePriceInput = $("#investInShare input[name=price]");
        var csrfToken =  $("input[name=csrfToken]");

        _guaranteeButton.on('click', guaranteeLoan);
        _guaranteeLoanId = $("#guarantee-loan-id").val();

        // Eather loanID + csrfToken are set OR shareId, share price and csrf token are set
        if((loanIdInput.length > 0 || (shareIdInput.length > 0 && sharePriceInput.length > 0)) && csrfToken.length > 0){
            if(loanIdInput.length > 0){
                _loanId = loanIdInput.val();
            }
            _csrfToken = csrfToken.val();

            _confirmView.removeClass('hide').css('display', 'none');

            _confirmLoanView.removeClass('hide').css('display', 'none');
            _showConfirmLoanInvestment.on('click', showConfirmLoanIssue );
            _hideConfirmLoanInvestment.on('click', hideConfirmLoanIssue );
            _confirmLoanCheckbox.change(updateLoanSubmitDisabled);
            _investLoanAmountElement.on('change', updateLoanPrice);

            _investProfileLoanElement.on('change', displayLoanFundingText);
            _investInLoanButton.on('click', investInLoan);

        }

        _withdrawButton.on('click', transfereToBank);
        _transfereButton.on('click', transfereToFundu);

        return checkShareElements();
    };

    var checkShareElements = function() {

        var shareIdInput =  $("#investInShare input[name=shareId]");
        var sharePriceInput = $("#investInShare input[name=price]");
        var shareMin =  $("#investInShare input[name=min]");
        var shareMax = $("#investInShare input[name=max]");
        var sharesAvailable = $("#investInShare input[name=available]");
        var csrfToken =  $("input[name=csrfToken]");

        if(shareIdInput.length > 0 && sharePriceInput.length > 0 && csrfToken.length > 0) {
            _shareId = shareIdInput.val().replace(/\s+/gi, '');
            _sharePrice = parseFloat(sharePriceInput.val().replace(/\s+/gi, ''));
            _minimumShares = parseInt(shareMin.val());
            _maximumShares = parseInt(shareMax.val());
            _availableShares = parseInt(sharesAvailable.val());

            // We mush have a correct amount
            if(isNaN(_minimumShares))
                return false;

            _investShareAmountElement.on('change', updatePrice);
            _investProfileShareElement.on('change', updatePrice);
            _showConfirmShareInvestment.on('click', showConfirmShareIssue );
            _hideConfirmShareInvestment.on('click', hideConfirmShareIssue );

            _confirmCheckbox.change(toggleIdentify);

            _investInShareButton.on('click', investInShare);
            _transferAndInvestInShareButton.on('click', investInShare);
        }

        return true;
    };

    var lock = function(menu) {
        if (_error) return false;

        if(menu === "transaction"){
            _lockState = true;
            _transactionMenuElement.addClass("processing");
        }
    }

    var unlock = function(menu) {
        if (_error) return false;

        if(menu === "transaction"){
            _lockState = false;
            _transactionMenuElement.removeClass("processing");
        }
    }

    // Init
    ///////////////////////////
    var initialize = function() {
        selectElements();
        var success = checkElements();

        if (success) {
            _isInitialized = true;
            return true;
        }

        return false;
    }

    var updateLoanPrice = function(ev){
        var amount = parseFloat($(this).val().replace(",", "."));

        if(!isNaN(amount) && amount > 0){
            // Move to formats.js
            var newPrice = amount.toFixed(2).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ");
            _confirmLoanAmount.text( newPrice );
        }
    }

    var checkProfile = function(profile, area) {
        // TO-DO: Check is valid UUID
        if( !profile ||
            profile.length === 0 ||
            typeof profile !== "string" ||
            !profile in _balances
          ){
            Fundu.Helpers.Notify.error(area, "error.group.not.selected");
            return false;
        }

        return true;
    }

    var checkAmount = function(amount, area) {
        if (isNaN(amount) || amount < 0) {
            Fundu.Helpers.Notify.error(area, "error.amount.unrecognised");
            return false;
        } else if (amount === 0) {
            Fundu.Helpers.Notify.error(area, "error.amount.min");
            return false;
        }

        return true;
    }

    var checkBalance = function(amount, profile, area) {
        if (_balances[profile] < 0) {
            Fundu.Helpers.Notify.error(area, "error.account.balance.negative");
            return false;
        } else if (_balances[profile] < amount) {
            Fundu.Helpers.Notify.error(area, "error.account.balance.insufficient");
            return false;
        }

        return true;
    }

    var updateLoanSubmitDisabled = function () {
        var status = !(_confirmLoanCheckbox.is(':checked'))
        _investInLoanButton.prop("disabled", status);
    }

    var validateTransfere = function(data){
        return $.ajax({
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            url: jsRoutes.controllers.AccountCtrl.validateBankTransfer().url
        })

        .done(function(res) {
            return true;
        })

        .fail(function(res, error) {
            if("error" in res.responseJSON){
                if(typeof res.responseJSON.error === "object" && "message" in res.responseJSON.error){
                    if(res.error.message === "error.transaction.to.bank.not.min"){
                        Fundu.Helpers.Notify.error("transfer", Fundu.Helpers.Notify.translate(res.error.message, res.error.minimum), true);
                    }
                }
                else{
                    switch(res.responseJSON.error){
                        case "error.transaction.to.bank.missing.iban":
                            var link = '<a href="/settings/user">' + Msg("common.term.here") + '</a>';
                            var htmlError = Fundu.Helpers.Notify.translate("error.transaction.to.bank.missing.iban", link);
                            Fundu.Helpers.Notify.html("error", "transfer", htmlError, 0);
                        break;

                        default:
                            Fundu.Helpers.Notify.error("transfer", res.error);
                        break;
                    }
                }
            }
            else{
                _error = Fundu.Helpers.Defaults.Response.error("registration", error);
            }
            return false;
        });
    }

    var preparePayByWay = function(data){
        return $.ajax({
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            url: jsRoutes.controllers.AccountCtrl.beforePayByWayTransfer().url
        })

        .done(function(res) {
            if("pbwToken" in res){
                _pbwHash = res.pbwToken;
            }
        })

        .fail(function(res) {
            console.log(res.responseText);
        });
    }

    var showConfirmLoanIssue = function(ev){
        if(ev)
            ev.preventDefault();

        var selectedProfile = _investProfileLoanElement.val();
        var amount = parseFloat(_investLoanAmountElement.val().replace(',','.').replace('€', ''));
        var area = "invest";

        if (checkProfile(selectedProfile, area) && checkAmount(amount, area) && checkBalance(amount, selectedProfile, area)) {
            _investInLoanElement.hide();
            _confirmLoanView.velocity("fadeIn", 200);
        }
    }

    var hideConfirmLoanIssue = function(ev){
        if(ev)
            ev.preventDefault();

        _confirmLoanView.hide();
        _investInLoanElement.velocity("fadeIn", 200);
    }

    // Public Methods
    ///////////////////////////

    var guaranteeLoan = function(ev){
        if(ev)
            ev.preventDefault();

        var loan = _guaranteeLoanId;
        var amount = parseFloat(_guaranteeAmount.val().replace(',','.').replace('€', ''));

        // To-do: Check that it isn't more than the loan
        if( !isNaN(amount) && amount >= 1000 ){
            var data = {
                id: loan,
                amount: amount.toString()
            }

            $.redirect( jsRoutes.controllers.GuaranteeCtrl.guaranteeSuccess().url, data, "GET");
        }
        else{
            if(isNaN(amount)){
                Fundu.Helpers.Notify.error("guarantee", "error.amount.unrecognised");
            }
            else{
                // TO-DO: Replace 50 with configuration value
                Fundu.Helpers.Notify.error("guarantee", Fundu.Helpers.Notify.translate("error.guarantee.min", "1000"), true);
            }
        }

        return false;
    }

    var displayLoanFundingText = function (ev) {
        if(ev)
            ev.preventDefault();

        var loan = _loanId;
        var selectedProfile = _investProfileLoanElement.val();

        if(!checkProfile(selectedProfile, "invest"))
            return false;

        return $.ajax({
            type: "GET",
            contentType: "application/json",
            url: jsRoutes.controllers.LoanApplicationCtrl.originalFunding(loan, selectedProfile).url
        })

        .done(function(res) {
          var fundingTextBlock = $("#current-funding");

          if (res.amount) {
              _fundedAmount = res.amount;

              if (res.allocation === "true") {
                  fundingTextBlock.text(Fundu.Helpers.Notify.translate("success.loan.current.funding_via_allocator", _fundedAmount.toString()));
              } else {
                  fundingTextBlock.text(Fundu.Helpers.Notify.translate("success.loan.current.funding", _fundedAmount.toString()));
              }

              fundingTextBlock.show();
          } else {
            fundingTextBlock.hide();
          }
        })

        .fail(function(res) {
            console.log(res.responseText);
        });
    }

    var investInLoan = function(ev){
        if(ev)
            ev.preventDefault();

        var loan = _loanId;
        var selectedProfile = _investProfileLoanElement.val();
        var amount = parseFloat(_investLoanAmountElement.val().replace(',','.').replace('€', ''));
        var originalAmount = _fundedAmount;
        var area = "invest";

        if (! originalAmount) originalAmount = 0;

        if(!checkProfile(selectedProfile, area))
            return false;

        if (checkAmount(amount, area) && checkBalance(amount, selectedProfile, area)) {
            if(selectedProfile !== "personal"){
                var data = {
                    loanId: loan,
                    profile: selectedProfile,
                    amount: amount.toString(),
                    originalAmount: originalAmount.toString(),
                    csrfToken: _csrfToken
                }
            }else{
                var data = {
                    loanId: loan,
                    amount: amount.toString(),
                    originalAmount: originalAmount.toString(),
                    csrfToken: _csrfToken
                }
            }

            if (!investmentRequestLock) {
                // prevent double investing
                investmentRequestLock = true;
                $.redirect( jsRoutes.controllers.LoanApplicationCtrl.doInvest().url, data, "POST");
            }
        }

        return false;
    }

    var transfereToFundu = function(ev){
        if(ev)
            ev.preventDefault();

        var selectedProfile = _transfereInProfileElement.val();
        var amount = parseFloat(_transfereInAmountElement.val().replace(',','.').replace('€', ''));

        if(!checkProfile(selectedProfile, "transfer"))
            return;

        // TO-DO: Replace 10 with configuration value
        if( !isNaN(amount) && amount >= 10 ){
            if(selectedProfile !== "personal"){
                var data = {
                    profileId: selectedProfile,
                    amount: amount.toString(),
                    successUrl: "/success?title=transfere.action.deposit.title&message=transfere.action.deposit.description",
                    failUrl: "/fail"
                }
            }else{
                var data = {
                    amount: amount.toString(),
                    successUrl: "/success?title=transfere.action.deposit.title&message=transfere.action.deposit.description",
                    failUrl: "/fail"
                }
            }

            var validate = preparePayByWay(data);
            if(validate){
                validate.done(function(){
                    if(_pbwHash){
                        window.location.href = "https://www.vismapay.com/pbwapi/token/" + _pbwHash;
                    }
                });
            }
        }
        else{
            if(isNaN(amount)){
                Fundu.Helpers.Notify.error("transfer", "error.amount.unrecognised");
            }
            else{
                // TO-DO: Replace 10 with configuration value
                Fundu.Helpers.Notify.error("transfer", Fundu.Helpers.Notify.translate("error.transaction.to.fundu.not.min", "10€"), true);
            }
        }

        return false;
    }

    var transfereToBank = function(ev){
        if(ev)
            ev.preventDefault();

        var selectedProfile = _transfereOutProfileElement.val();
        var amount = parseFloat(_transfereOutAmountElement.val().replace(',','.').replace('€', ''));
        var area = "transfer";

        if(!checkProfile(selectedProfile, area))
            return;

        if (checkAmount(amount, area) && checkBalance(amount, selectedProfile, area)) {

            // To-DO: Get 1 from application configuration
            if(amount < 1 ){
                Fundu.Helpers.Notify.error("transfer", Fundu.Helpers.Notify.translate("error.transaction.to.bank.not.min", "1€"), true);
                return false;
            }

            if(selectedProfile !== "personal"){
                var data = {
                    profile: selectedProfile,
                    amount: amount.toString()
                }
            }else{
                var data = {
                    amount: amount.toString()
                }
            }

            var validate = validateTransfere(data);
            if(validate){
                validate.success(function(){
                    window.location.href = jsRoutes.controllers.AccountCtrl.transferToBank().url;
                });
            }
        }

        return false;
    }

    // Methods for share investing. These could be refactored to a separate file
    // ############################################################################

    var updatePrice = function(ev) {
        var amount = parseInt(_investShareAmountElement.val().replace(",", "."));
        var price = calculatePrice(amount);
        var profile = _investProfileShareElement.val();
        var accountBalance = _balances[profile];

        // Move to formats.js
        var priceStr = price.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ");

        _sharePriceTotal.text(priceStr + "€");
        _confirmAmount.text(amount);
        _confirmPriceTotal.text(priceStr);

        if (accountBalance > 0 && accountBalance < price) {
            var amountToTransfer = parseFloat(Math.round((price - _balances[profile]) * 100) / 100).toFixed(2);
            _amountToTransfer.text(amountToTransfer);
            _amountToTransferSpan.show();
            _investInShareButton.hide();
            _transferAndInvestInShareButton.show();
        } else {
            _amountToTransferSpan.hide();
            _investInShareButton.show();
            _transferAndInvestInShareButton.hide();
        }
    };

    var calculatePrice = function(amount) {
        if (!isNaN(amount) && (amount * _sharePrice) > 0) {
            return (amount * _sharePrice);
        }
        return 0;
    };

    var toggleIdentify = function(ev){
        _investInShareButton.prop("disabled", !_investInShareButton.prop("disabled"));
        _transferAndInvestInShareButton.prop("disabled", !_transferAndInvestInShareButton.prop("disabled"));
    }

    var investmentRequestLock = false;

    var investInShare = function(ev) {
        if(ev)
            ev.preventDefault();

        if( !_confirmCheckbox.prop( "checked" ) )
            return false;

        var share = _shareId;

        var selectedProfile = _investProfileShareElement.val();
        var shareCount = parseInt(_investShareAmountElement.val());
        var price = calculatePrice(shareCount);
        var area = "invest";

        if(!checkProfile(selectedProfile, area))
            return false;

        if (checkAmount(shareCount, area) && checkShareCount(shareCount, area)) {
            if (!investmentRequestLock) {
                // prevent double investing
                investmentRequestLock = true;

                var groupId = selectedProfile !== "personal" ? selectedProfile : null;

                if (_balances[selectedProfile] < price) {
                    var moneyTransferData = {
                        profileId: groupId,
                        amount: parseFloat(Math.round((price - _balances[selectedProfile]) * 100) / 100).toFixed(2),
                        successUrl: jsRoutes.controllers.ShareCtrl.doInvestRedirect(share, shareCount, true, groupId).url,
                        failUrl: "/fail"
                    }

                    var validate = preparePayByWay(moneyTransferData);
                    if (validate) {
                        validate.done(function() {
                            if (_pbwHash) {
                                window.location.href = "https://www.vismapay.com/pbwapi/token/" + _pbwHash;
                            }
                        });
                    }
                } else {
                    return $.ajax({
                        type: "GET",
                        contentType: "application/json",
                        url: jsRoutes.controllers.ShareCtrl.doInvest(share, shareCount, true, groupId).url
                    })
                    .done(function (res) {
                        if ("redirect" in res) {
                            window.location.href = res.redirect;
                        }
                    })
                    .fail(function (res) {
                        investmentRequestLock = false;
                    });
                }
            }
        }

        return false;
    };

    var hideConfirmShareIssue = function(ev){
        if(ev)
            ev.preventDefault();

        _confirmView.hide();
        _investInShareElement.velocity("fadeIn", 200);
    };

    var showConfirmShareIssue = function(ev){
        if(ev)
            ev.preventDefault();

        var selectedProfile = _investProfileShareElement.val();
        var shareCount = parseInt(_investShareAmountElement.val());
        var price = calculatePrice(shareCount);
        var area = "invest";

        if (checkProfile(selectedProfile, area) && checkAmount(shareCount, area) && checkShareCount(shareCount, area)) {
            _investInShareElement.hide();
            _confirmView.velocity("fadeIn", 200);
        }
    };

    var checkShareCount = function(shareCount, area) {
        var minShares = _minimumShares;
        var maxShares = _maximumShares ? Math.min(_maximumShares, _availableShares) : _availableShares;

        if (shareCount < minShares) {
            Fundu.Helpers.Notify.error(area, Fundu.Helpers.Notify.translate("error.share.min", minShares), true);
            return false;
        } else if (shareCount > maxShares) {
            Fundu.Helpers.Notify.error(area, Fundu.Helpers.Notify.translate("error.share.max", maxShares), true);
            return false;
        }

        return true;
    };

    // ############################################################################
    // End of share investing specific code

    // Reveal public methods
    return {
        init: initialize
    }

})(jQuery)
